<script>
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },

    pagination: {
      type: Object,
      default: () => ({})
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    view(id) {
      this.$emit('view', id)
    },

    handleCurrentChange(page) {
      this.$emit('pageChange', page)
    }
  },

  render() {
    const DataTable = () => {
      const DetailButton = ({ props }) => (
        <el-button
          size="medium"
          onClick={() => {
            this.view(props.dataId)
          }}
        >
          See Detail <i class="el-icon-arrow-right"></i>
        </el-button>
      )

      return (
        <el-table
          data={this.items}
          headerCellClassName={elementUiStyles.tableCell}
          cellClassName={elementUiStyles.tableCell}
          style={{ marginBottom: '1rem' }}
        >
          <el-table-column
            label="No."
            prop="index"
            align="right"
            minWidth="70"
          />
          <el-table-column label="ช่องทางชำระ" prop="type" minWidth="100" />
          <el-table-column label="ธนาคาร" prop="bank" minWidth="150" />
          <el-table-column
            label="เลขที่บัญชี"
            prop="accountNo"
            minWidth="150"
          />
          <el-table-column
            label="ชื่อบัญชี"
            prop="accountName"
            minWidth="200"
          />
          <el-table-column
            width="150"
            scopedSlots={{
              default: ({ row }) =>
                row.id !== 1 ? <DetailButton dataId={row.id} /> : null
            }}
          />
        </el-table>
      )
    }

    const Pagination = () => (
      <div
        style={{
          display: 'flex',
          overflow: 'auto hidden'
        }}
      >
        <el-pagination
          background
          currentPage={this.pagination.page}
          total={this.pagination.total}
          pageSize={this.pagination.pageSize}
          layout="prev, pager, next, jumper"
          style={{ margin: 'auto' }}
          on={{
            'current-change': this.handleCurrentChange
          }}
        />
      </div>
    )

    return (
      <el-card
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
        {...{ directives: [{ name: 'loading', value: this.loading }] }}
      >
        <DataTable />
        <Pagination />
      </el-card>
    )
  }
}
</script>
